import type { InClassRecordRequest } from '@/models/interface/courseRecord';
import type { ObserveRecordReq, ObserveRecordRes } from '@/models/interface/reports';
import type { ICourseRecordLiveLesson } from '@/models/interface/statistics';
import { ApiFactory, type ApiDataResponse } from '@/utils/api';

export class userReportsService extends ApiFactory {
  constructor() {
    super('UserReports');
  }

  getObserveRecord(params: ObserveRecordReq): Promise<ApiDataResponse<ObserveRecordRes>> {
    return super.get('ObserveRecord', params);
  }

  searchCourseRecord(params: InClassRecordRequest): Promise<ApiDataResponse<ICourseRecordLiveLesson>> {
    return super.post('InClassRecordV2', params);
  }
}
